function createFormHTML(output) {
    return `
    <html>
        <body>
            <form 
                id="payment-provider-form"
                name="payment-provider-form" 
                method="POST"
                action="${output.url}"
            >
                ${Object.keys(output.parameters)
        .map((key) => {
        const value = output.parameters[key];
        return `<input type="hidden" name="${key}" value="${value}" />`;
    })
        .join('\n')}
            </form>
            <script>
                const form = document.getElementById('payment-provider-form');
                if(form){ form.submit();}
            </script>
        </body>
    </html>
    `;
}

export { createFormHTML };
